<script>
import PinchZoom from 'pinch-zoom'
import DOMUtils from '@/utils/DOMUtils'
import FileUtils from '@/utils/fileUtils'
import FileReaderUtils from '@/utils/fileReaderUtils'
import EnvironmentUtils from '@/utils/environmentUtils'

export default
{
    name: 'image-enlarger',

    props:
    {
        src: { type: String }
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='image-enlarger'>
                <div on-click={e => this.enlargeImage(e.target.src)} class='src-image-elem-wrapper'>
                    <img v-show={this.src} class='src-image-elem' src={this.src} />
                    {this.$slots.default}
                </div>

                <div v-show={this.isModalVisible} class='modal'>
                    <div class='background' on-click={this.closeModal} />
                    <div class='content'>
                        <div class='actions-bar'>
                            <inline-svg class='icon' src={require('@/assets/img/download.svg')} on-click={this.downloadImage} />
                            <inline-svg class='icon close' src={require('@/assets/img/cross.svg')} on-click={this.closeModal} />
                        </div>
                        <div class='zoom-zone' ref='zoomZone'>
                            <img class='image' src={this.imageSrc} />
                        </div>
                    </div>
                </div>
            </div>
        )
    },

    mounted ()
    {
        if (this.src) this.imageSrc = this.src
        this.pinchZoom = PinchZoom(this.$refs.zoomZone, {draggable: true, maxScale: 4})
    },

    data () 
    {
        return {
            isModalVisible: false,
            imageSrc: null,
            pinchZoom: null
        }
    },

    computed:
    {
    },

    watch:
    {
        isModalVisible ()
        {
            DOMUtils.toggleBodyScrolling(!this.isModalVisible)
            this.pinchZoom.reset()
        }
    },
    
    beforeDestroy ()
    {
        DOMUtils.toggleBodyScrolling(true)
    },

    methods:
    {
        /**
         * @param imgSrc {string}
         */
        enlargeImage (imgSrc)
        {
            this.imageSrc = imgSrc
            this.isModalVisible = true
        },

        closeModal ()
        {
            this.imageSrc = null
            this.isModalVisible = false
        },

        async downloadImage ()
        {
            if (!this.imageSrc) throw new Error('Can\'t download image, no image source.', this)

            const blob = await FileReaderUtils.srcToBlobAsync(this.imageSrc)
            await FileUtils.writeFileToDownloadsAsync('image téléchargée depuis l\'app ' + EnvironmentUtils.cityName, blob)
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.image-enlarger
{
    width: inherit;

    > .src-image-elem-wrapper, .src-image-elem
    {
        width: inherit;
        height: inherit;
        max-height: inherit;
        cursor: pointer;
        object-fit: cover
    }

    > .modal
    {
        position: fixed;
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
        z-index: 3;

        > .background
        {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: -1;
            background-color: #000000e0;
        }

        > .content
        {
            display: flex;
            flex-direction: column;
            height: 100%;
            margin-top: var(--theme-status-bar-height);

            .OnDesktop({ margin-top: 0; });

            > .actions-bar
            {
                width: -webkit-fill-available;
                display: flex;
                flex-direction: row-reverse;
                align-items: center;
                z-index: 1;
                filter: drop-shadow(0px 2px 1px rgba(0, 0, 0, 0.4));
                padding: 10px;

                .OnDesktop({ padding: 20px; });

                > .icon
                {
                    fill: white;
                    .WidthHeight(25px);
                    cursor: pointer;

                    &.close
                    {
                        .WidthHeight(18px);
                        margin-right: auto;
                    }
                }
            }

            > .zoom-zone
            {
                width: 100%;
                margin-top: auto;
                margin-bottom: auto;
                padding-bottom: 40%;

                > .image
                {
                    width: 100%;
                    display: block;
                    height: auto;
                    margin-top: auto;
                    margin-bottom: auto;

                    .OnDesktop({
                        max-height: 90vh;
                        object-fit: contain;
                    });
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ImageEnlarger.vue